
mutation orderResultUpdate($error_message: String, $data: JSON!) {
    orderResultUpdate(error_message: $error_message, data: $data) 
}
